export const colors = {
  primary: {
    light: '#69a1ff',
    main: '#1a73e8',
    dark: '#0049b5',
    contrastText: '#ffffff',
  },
  secondary: {
    light: '#fff04e',
    main: '#f5be02',
    dark: '#bd8e00',
    contrastText: '#ffffff',
  },
  textPrimary: 'rgba(52, 61, 72, 0.85);',
  textSecondary: 'rgba(0,0,0, 0.54)',
  defaultBackground: '#fafafa',

  others: {
    white: '#ffffff',
    whitesmoke: '#f5f6f7',
    black: '#24292e',
    dark: '#444444',
    greylight: '#e6e6e6',
    grey: '#bdbdbd',
    steelblue: 'rgb(101, 119, 134)',
    red: '#ef5350',
    redlight: '#ffcdd2',
  },
};
